// extracted by mini-css-extract-plugin
export default {"form":"SearchForm_form__o80os","input":"SearchForm_input__HOxJo","search_btn":"SearchForm_search_btn__LkBSl"};